import React, { useEffect, useRef, useState } from 'react';
import styles from './MisReportsGraphs.module.scss';
import ReactECharts from 'echarts-for-react';
import { commonVaribles } from 'src/constants/constVariables';

const IncoTermwiseCostBarChart = ({ IncoTermWiseCostData }) => {
	const [chartOptions, setChartOptions] = useState({});
	const chartRef = useRef(null);

	const getChartOptions = () => {
		return {
			series: [
				{
					name: 'FH Packaging Cost',
					type: 'bar',
					stack: 'Total FH Cost', // Stack the bars
					data: IncoTermWiseCostData?.total_fh_packaging_cost_array,
					barGap: '50%', // Set the gap between bars
					barWidth: window.innerWidth <= 600 ? 15 : 30,
					itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [
								{ offset: 0, color: '#F3D17A' },
								{ offset: 0.5, color: '#FABC74' },
								{ offset: 1, color: '#F1B379' },
							],
						},
						barBorderRadius: [0, 0, 10, 10], // Top-left and top-right corners rounded
						borderWidth: 1,
					},
					label: {
						show: true,
						position: 'inside',
						color: 'black',
						fontSize: 12,
					},
				},
				{
					name: 'FH Transportation Cost',
					type: 'bar',
					stack: 'Total FH Cost', // Stack the bars
					data: IncoTermWiseCostData?.total_fh_transportation_cost_array,
					barGap: '50%', // Set the gap between bars
					barWidth: window.innerWidth <= 600 ? 15 : 30,
					itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [
								{ offset: 0, color: '#57DA65' },
								{ offset: 0.5, color: '#51CC5D' },
								{ offset: 1, color: '#46A46C' },
							],
						},
						barBorderRadius: [10, 10, 0, 0], // Top-left and top-right corners rounded
						borderWidth: 1,
					},
					label: {
						show: true,
						position: 'inside',
						color: 'black',
						fontSize: 12,
					},
				},
				{
					name: 'Label', // Label
					type: 'bar',
					stack: 'Total FH Cost', // Stack the bars
					data: IncoTermWiseCostData?.total_fh_transportation_cost_array.map(
						() => 0
					),
					barGap: '50%', // Set the gap between bars
					barWidth: window.innerWidth <= 600 ? 15 : 30,
					itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [
								{ offset: 0, color: '#57DA65' },
								{ offset: 0.5, color: '#51CC5D' },
								{ offset: 1, color: '#46A46C' },
							],
						},
						barBorderRadius: [10, 10, 0, 0], // Top-left and top-right corners rounded
						borderWidth: 1,
					},
					label: {
						show: true,
						position: 'top',
						color: 'black',
						fontSize: 12,
						// fontWeight: "bold",
						formatter: 'FH',
					},
				},
				{
					name: 'FLS Packaging Cost',
					type: 'bar',
					stack: 'Total FLS Cost', // Stack the bars
					data: IncoTermWiseCostData?.total_fls_packaging_cost_array,
					barGap: '50%', // Set the gap between bars
					barWidth: window.innerWidth <= 600 ? 15 : 30,
					itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [
								{ offset: 0, color: '#F3D17A' },
								{ offset: 0.5, color: '#FABC74' },
								{ offset: 1, color: '#F1B379' },
							],
						},
						barBorderRadius: [0, 0, 10, 10], // Top-left and top-right corners rounded
						borderWidth: 1,
					},
					label: {
						show: true,
						position: 'inside',
						color: 'black',
						fontSize: 12,
					},
				},
				{
					name: 'FLS Transportation Cost',
					type: 'bar',
					stack: 'Total FLS Cost', // Stack the bars
					data: IncoTermWiseCostData?.total_fls_transportation_cost_array,
					barGap: '50%', // Set the gap between bars
					barWidth: window.innerWidth <= 600 ? 15 : 30,
					itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [
								{ offset: 0, color: '#57DA65' },
								{ offset: 0.5, color: '#51CC5D' },
								{ offset: 1, color: '#46A46C' },
							],
						},
						barBorderRadius: [10, 10, 0, 0], // Top-left and top-right corners rounded
						borderWidth: 1,
					},
					label: {
						show: true,
						position: 'inside',
						color: 'black',
						fontSize: 12,
					},
				},
				{
					name: 'Label', // Label
					type: 'bar',
					stack: 'Total FLS Cost', // Stack the bars
					data: IncoTermWiseCostData?.total_fh_transportation_cost_array.map(
						() => 0
					),
					barGap: '50%', // Set the gap between bars
					barWidth: window.innerWidth <= 600 ? 15 : 30,
					itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [
								{ offset: 0, color: '#57DA65' },
								{ offset: 0.5, color: '#51CC5D' },
								{ offset: 1, color: '#46A46C' },
							],
						},
						barBorderRadius: [10, 10, 0, 0], // Top-left and top-right corners rounded
						borderWidth: 1,
					},
					label: {
						show: true,
						position: 'top',
						color: 'black',
						fontSize: 12,
						// fontWeight: "bold",
						formatter: 'FLS',
					},
				},
				{
					name: 'FCA Packaging Cost',
					type: 'bar',
					stack: 'Total FCA Cost', // Stack the bars
					data: IncoTermWiseCostData?.total_fca_packaging_cost_array,
					barGap: '50%', // Set the gap between bars
					barWidth: window.innerWidth <= 600 ? 15 : 30,
					itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [
								{ offset: 0, color: '#F3D17A' },
								{ offset: 0.5, color: '#FABC74' },
								{ offset: 1, color: '#F1B379' },
							],
						},
						barBorderRadius: [0, 0, 10, 10], // Top-left and top-right corners rounded
						borderWidth: 1,
					},
					label: {
						show: true,
						position: 'inside',
						color: 'black',
						fontSize: 12,
					},
				},
				{
					name: 'FCA Transportation Cost',
					type: 'bar',
					stack: 'Total FCA Cost', // Stack the bars
					data: IncoTermWiseCostData?.total_fca_transportation_cost_array,
					barGap: '50%', // Set the gap between bars
					barWidth: window.innerWidth <= 600 ? 15 : 30,
					itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [
								{ offset: 0, color: '#57DA65' },
								{ offset: 0.5, color: '#51CC5D' },
								{ offset: 1, color: '#46A46C' },
							],
						},
						barBorderRadius: [10, 10, 0, 0], // Top-left and top-right corners rounded
						borderWidth: 1,
					},
					label: {
						show: true,
						position: 'inside',
						color: 'black',
						fontSize: 12,
					},
				},
				{
					name: 'Label', // Label
					type: 'bar',
					stack: 'Total FCA Cost', // Stack the bars
					data: IncoTermWiseCostData?.total_fh_transportation_cost_array.map(
						() => 0
					),
					barGap: '50%', // Set the gap between bars
					barWidth: window.innerWidth <= 600 ? 15 : 30,
					itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [
								{ offset: 0, color: '#57DA65' },
								{ offset: 0.5, color: '#51CC5D' },
								{ offset: 1, color: '#46A46C' },
							],
						},
						barBorderRadius: [10, 10, 0, 0], // Top-left and top-right corners rounded
						borderWidth: 1,
					},
					label: {
						show: true,
						position: 'top',
						color: 'black',
						fontSize: 12,
						// fontWeight: "bold",
						formatter: 'FCA',
					},
				},
				{
					name: 'Exworks Packaging Cost',
					type: 'bar',
					stack: 'Total Exworks Cost', // Stack the bars
					data: IncoTermWiseCostData?.total_exworks_packaging_cost_array,
					barGap: '50%',
					barWidth: window.innerWidth <= 600 ? 15 : 30,
					itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [
								{ offset: 0, color: '#F3D17A' },
								{ offset: 0.5, color: '#FABC74' },
								{ offset: 1, color: '#F1B379' },
							],
						},
						barBorderRadius: [0, 0, 10, 10], // Top-left and top-right corners rounded
						borderWidth: 1,
					},
					label: {
						show: true,
						position: 'inside',
						color: 'black',
						fontSize: 12,
					},
				},
				{
					name: 'Exworks Transportation Cost',
					type: 'bar',
					stack: 'Total Exworks Cost', // Stack the bars
					data: IncoTermWiseCostData?.total_exworks_transportation_cost_array,
					barGap: '50%',
					barWidth: window.innerWidth <= 600 ? 15 : 30,
					itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [
								{ offset: 0, color: '#57DA65' },
								{ offset: 0.5, color: '#51CC5D' },
								{ offset: 1, color: '#46A46C' },
							],
						},
						barBorderRadius: [10, 10, 0, 0], // Top-left and top-right corners rounded
						borderWidth: 1,
					},
					label: {
						show: true,
						position: 'inside',
						color: 'black',
						fontSize: 12,
					},
				},
				{
					name: 'Label', // Label
					type: 'bar',
					stack: 'Total Exworks Cost', // Stack the bars
					data: IncoTermWiseCostData?.total_fh_transportation_cost_array.map(
						() => 0
					),
					barGap: '50%', // Set the gap between bars
					barWidth: window.innerWidth <= 600 ? 15 : 30,
					itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [
								{ offset: 0, color: '#57DA65' },
								{ offset: 0.5, color: '#51CC5D' },
								{ offset: 1, color: '#46A46C' },
							],
						},
						barBorderRadius: [10, 10, 0, 0], // Top-left and top-right corners rounded
						borderWidth: 1,
					},
					label: {
						show: true,
						position: 'top',
						color: 'black',
						fontSize: 12,
						// fontWeight: "bold",
						formatter: 'Exworks',
					},
				},
			],
			title: {
				text: 'Inco Term wise Cost (Cr)',
				left: 'left',
				textStyle: {
					color: '#000000', // Set title text color to black
					fontFamily: 'OpensansRegular',
				},
			},
			tooltip: {
				trigger: 'axis',
				axisPointer: {
					type: 'shadow', // Keep the shadow pointer for stacked bars
				},
				formatter: function (params) {
					let tooltipText = `<b>${params[0].axisValue}</b><br/>`; // Show the plant name (x-axis value)

					// Colors directly from series
					const packagingColor = '#F1B379'; // From the packaging series
					const transportationColor = '#46A46C'; // From the transportation series

					// Get the total cost and add it with consistent styling
					const totalCostIndex = params[0].dataIndex; // Use the dataIndex of the first param to find the index
					const totalCost =
						IncoTermWiseCostData?.total_recommended_sheet_cost_array[
							totalCostIndex
						]; // Access the total cost array

					// Add the total cost to the tooltip

					const fhPackagingCountIndex = params[0].dataIndex; // Use the dataIndex of the first param to find the index
					const fhPackagingCount =
						IncoTermWiseCostData?.fh_packaging_count[fhPackagingCountIndex];

					const flsPackagingCountIndex = params[0].dataIndex; // Use the dataIndex of the first param to find the index
					const flsPackagingCount =
						IncoTermWiseCostData?.fls_packaging_count[flsPackagingCountIndex];

					const fcaPackagingCountIndex = params[0].dataIndex; // Use the dataIndex of the first param to find the index
					const fcaPackagingCount =
						IncoTermWiseCostData?.fca_packaging_count[fcaPackagingCountIndex];

					const exworksPackagingCountIndex = params[0].dataIndex; // Use the dataIndex of the first param to find the index
					const exworksPackagingCount =
						IncoTermWiseCostData?.exworks_packaging_count[
							exworksPackagingCountIndex
						];

					// Iterate over the series (Packaging and Transportation)
					params.forEach((param) => {
						let seriesColor;
						if (param.seriesName === 'Label') {
							return;
						}
						if (param.seriesName.includes('Packaging Cost')) {
							seriesColor = packagingColor; // Assign packaging color
						} else if (param.seriesName.includes('Transportation Cost')) {
							seriesColor = transportationColor; // Assign transportation color
						}

						// let countData = 0;
						// if (param.seriesName.includes('FH')) {
						//   countData = fhPackagingCount;
						// } else if (param.seriesName.includes('FLS')) {
						//   countData = flsPackagingCount;
						// } else if (param.seriesName.includes('FCA')) {
						//   countData = fcaPackagingCount;
						// } else if (param.seriesName.includes('Exworks')) {
						//   countData = exworksPackagingCount;
						// }

						// Iterate over the data points (FCA, Exworks)
						// Add colored square for series name
						tooltipText += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${seriesColor}"></span>`;
						// Adjusted spacing, now the value will appear aligned to the right
						// tooltipText += `${param.seriesName} (${countData}): <span style="float:right;">(${countData}) ${param.value} (${countData})</span><br/>`;
						tooltipText += `${param.seriesName}: <span style="float:right;">${param.value}</span><br/>`;
					});

					// Get the total cost and add it with consistent styling
					// const totalCostIndex = params[0].dataIndex; // Use the dataIndex of the first param to find the index
					// const totalCost = IncoTermWiseCostData?.total_recommended_sheet_cost_array[totalCostIndex]; // Access the total cost array

					// Add the total cost to the tooltip
					tooltipText += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#817AF3"></span>`;
					tooltipText += `<strong>Total Cost: <span style="float:right;">${totalCost?.toFixed(2)}</span></strong><br/>`; // Display total cost with consistent styling

					// const fhPackagingCountIndex = params[0].dataIndex; // Use the dataIndex of the first param to find the index
					// const fhPackagingCount = IncoTermWiseCostData?.fh_packaging_count[fhPackagingCountIndex];

					tooltipText += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#F1B379"></span>`;
					tooltipText += `<strong>FH Packaging Count: <span style="float:right;">${fhPackagingCount?.toFixed(0)}</span></strong><br/>`;

					// const flsPackagingCountIndex = params[0].dataIndex; // Use the dataIndex of the first param to find the index
					// const flsPackagingCount = IncoTermWiseCostData?.fls_packaging_count[flsPackagingCountIndex];

					tooltipText += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#817AF3"></span>`;
					tooltipText += `<strong>FLS Packaging Count: <span style="float:right;">${flsPackagingCount?.toFixed(0)}</span></strong><br/>`;

					// const fcaPackagingCountIndex = params[0].dataIndex; // Use the dataIndex of the first param to find the index
					// const fcaPackagingCount = IncoTermWiseCostData?.fca_packaging_count[fcaPackagingCountIndex];

					tooltipText += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#817AF3"></span>`;
					tooltipText += `<strong>FCA Packaging Count: <span style="float:right;">${fcaPackagingCount?.toFixed(0)}</span></strong><br/>`;

					// const exworksPackagingCountIndex = params[0].dataIndex; // Use the dataIndex of the first param to find the index
					// const exworksPackagingCount = IncoTermWiseCostData?.exworks_packaging_count[exworksPackagingCountIndex];

					tooltipText += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#817AF3"></span>`;
					tooltipText += `<strong>Exworks Packaging Count: <span style="float:right;">${exworksPackagingCount?.toFixed(0)}</span></strong><br/>`;

					return tooltipText; // Return the complete tooltip text
				},
			},

			legend: {
				// data: ["FH Packaging Cost", "FH Transportation Cost","FLS Packaging Cost", "FLS Transportation Cost","FCA Packaging Cost", "FCA Transportation Cost","Exworks Packaging Cost", "Exworks Transportation Cost"],
				data: ['FH Packaging Cost', 'FH Transportation Cost'],
				right: '1%',
				top: '5%',
				orient: 'horizontal',
				formatter: function (name) {
					if (name?.includes('Packaging Cost')) {
						return 'Packaging Cost'; // Custom text with an emoji
					} else if (name?.includes('Transportation Cost')) {
						return 'Transportation Cost';
					}
				},
			},
			xAxis: [
				{
					type: 'category',
					data: IncoTermWiseCostData?.header_array,
					splitLine: {
						show: false, // Hide the separation line along the x-axis
					},
					axisLabel: {
						width: 130,
						rotate: 0,
						interval: 0,
					},
				},
			],
			yAxis: [
				{
					type: 'value',
					splitLine: {
						show: false, // Hide the grid lines on the y-axis
					},
					axisLine: {
						show: true, // Show y-axis line
					},
				},
			],
			grid: {
				backgroundColor: '#FFFF00', // Set the background color of the grid
			},
		};
	};

	useEffect(() => {
		const chartInstance = chartRef.current?.getEchartsInstance();
		if (!chartInstance) return;

		chartInstance.on('legendselectchanged', (params) => {
			const selected = params.selected;
			console.log('selected===', selected);
			const isPackagingSelected = selected['FH Packaging Cost'];
			const isTransportSelected = selected['FH Transportation Cost'];

			// Find all series names dynamically
			const allSeries = chartInstance.getOption().series.map((s) => s.name);

			// Filter packaging and transportation series dynamically
			const packagingSeries = allSeries.filter((name) =>
				name.includes('Packaging Cost')
			);
			const transportSeries = allSeries.filter((name) =>
				name.includes('Transportation Cost')
			);

			// Toggle visibility for packaging series
			packagingSeries.forEach((name) => {
				chartInstance.dispatchAction({
					type: isPackagingSelected ? 'legendSelect' : 'legendUnSelect',
					name,
				});
			});

			// Toggle visibility for transportation series
			transportSeries.forEach((name) => {
				chartInstance.dispatchAction({
					type: isTransportSelected ? 'legendSelect' : 'legendUnSelect',
					name,
				});
			});
		});
	}, []);

	useEffect(() => {
		setChartOptions(getChartOptions());

		// Update chart options on window resize
		const handleResize = () => {
			setChartOptions(getChartOptions());
		};

		window.addEventListener('resize', handleResize);

		// Cleanup event listener on component unmount
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [IncoTermWiseCostData]);

	return (
		<>
			{IncoTermWiseCostData?.header_array ? (
				<ReactECharts
					option={chartOptions}
					notMerge={true}
					className={styles['chart']}
					ref={chartRef}
				/>
			) : (
				<div className={styles.containers}>
					{' '}
					{commonVaribles.data_not_found}{' '}
				</div>
			)}
		</>
	);
};

export default IncoTermwiseCostBarChart;
